module.exports = __webpack_public_path__ + "12ec280a8a02e843db6f0d1db31cfd89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/og_image.png
// module id = 2465
// module chunks = 85